module.exports = __webpack_public_path__ + "assets/img/0605.2da89b28.png";